<div class="page-head">
  <div>
    <p class="eyebrow">การเงิน</p>
    <h1>รายการรับ–จ่าย</h1>
    <p>ติดตามกระแสเงินจากรายการรับชำระและรายการจ่ายที่ดำเนินการเรียบร้อยแล้ว</p>
  </div>
  <button
    type="button"
    class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] active:scale-[0.98]"
    (click)="exportExcel()"
  >
    <lucide-icon name="Download" [size]="17" />
    Export Excel
  </button>
</div>

<!-- <section class="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
  <article class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="flex items-start justify-between gap-4">
      <div>
        <p class="m-0 text-xs font-medium text-slate-500">รายรับตามตัวกรอง</p>
        <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">
          {{ incomeTotal() | number: '1.2-2' }}
        </p>
        <p class="mt-1 mb-0 text-xs text-slate-500">บาท · ตรวจสอบแล้ว</p>
      </div>
      <span class="grid size-10 shrink-0 place-items-center rounded-xl bg-emerald-50 text-emerald-600">
        <lucide-icon name="ArrowDownLeft" [size]="20" />
      </span>
    </div>
  </article>

  <article class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="flex items-start justify-between gap-4">
      <div>
        <p class="m-0 text-xs font-medium text-slate-500">รายจ่ายตามตัวกรอง</p>
        <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">
          {{ expenseTotal() | number: '1.2-2' }}
        </p>
        <p class="mt-1 mb-0 text-xs text-slate-500">บาท · จ่ายแล้ว</p>
      </div>
      <span class="grid size-10 shrink-0 place-items-center rounded-xl bg-rose-50 text-rose-600">
        <lucide-icon name="ArrowUpRight" [size]="20" />
      </span>
    </div>
  </article>

  <article class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="flex items-start justify-between gap-4">
      <div>
        <p class="m-0 text-xs font-medium text-slate-500">กระแสเงินสุทธิ</p>
        <p
          class="mt-2 mb-0 text-2xl font-bold tabular-nums"
          [class.text-emerald-700]="netTotal() >= 0"
          [class.text-rose-700]="netTotal() < 0"
        >
          {{ netTotal() | number: '1.2-2' }}
        </p>
        <p class="mt-1 mb-0 text-xs text-slate-500">บาท · รายรับหักรายจ่าย</p>
      </div>
      <span class="grid size-10 shrink-0 place-items-center rounded-xl bg-sky-50 text-sky-600">
        <lucide-icon name="WalletCards" [size]="20" />
      </span>
    </div>
  </article>

  <article class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="flex items-start justify-between gap-4">
      <div>
        <p class="m-0 text-xs font-medium text-slate-500">จำนวนรายการ</p>
        <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">
          {{ filteredItems().length | number }}
        </p>
        <p class="mt-1 mb-0 text-xs text-slate-500">รายการตามตัวกรอง</p>
      </div>
      <span class="grid size-10 shrink-0 place-items-center rounded-xl bg-violet-50 text-violet-600">
        <lucide-icon name="FileSpreadsheet" [size]="20" />
      </span>
    </div>
  </article>
</section> -->

<section class="mt-5 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
  <div class="border-b border-slate-200 p-4 sm:p-5">
  <div class="mb-4">
    <div>
      <h2 class="m-0 text-base font-bold text-slate-800">ตัวกรองรายการ</h2>
      <p class="mt-1 mb-0 text-xs text-slate-500">ยอดสรุปและตารางจะเปลี่ยนตามตัวกรองที่เลือก</p>
    </div>
  </div>

  <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">วันที่เริ่มต้น</span>
      <p-datepicker
        class="w-full"
        [ngModel]="pendingDateFrom()"
        (ngModelChange)="pendingDateFrom.set($event)"
        dateFormat="dd/mm/yy"
        placeholder="เลือกวันที่เริ่มต้น"
        [showIcon]="true"
        [showClear]="true"
        [readonlyInput]="true"
        appendTo="body"
      />
    </label>

    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">วันที่สิ้นสุด</span>
      <p-datepicker
        class="w-full"
        [ngModel]="pendingDateTo()"
        (ngModelChange)="pendingDateTo.set($event)"
        dateFormat="dd/mm/yy"
        placeholder="เลือกวันที่สิ้นสุด"
        [showIcon]="true"
        [showClear]="true"
        [readonlyInput]="true"
        appendTo="body"
      />
    </label>

    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">รับหรือจ่าย</span>
      <p-select
        class="w-full"
        [options]="directionOptions"
        [ngModel]="pendingDirection()"
        (ngModelChange)="pendingDirection.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="เลือกประเภทการรับ–จ่าย"
      />
    </label>

    <label class="block">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">ประเภทรายการ</span>
      <p-select
        class="w-full"
        [options]="categoryOptions"
        [ngModel]="pendingCategory()"
        (ngModelChange)="pendingCategory.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="เลือกประเภทรายการ"
      />
    </label>

    <label class="block md:col-span-2 xl:col-span-1">
      <span class="mb-1.5 block text-xs font-semibold text-slate-600">ช่องทางชำระ</span>
      <p-select
        class="w-full"
        [options]="paymentMethodOptions"
        [ngModel]="pendingPaymentMethod()"
        (ngModelChange)="pendingPaymentMethod.set($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="เลือกช่องทางชำระ"
      />
    </label>
  </div>

  <div class="mt-4 flex flex-wrap justify-center gap-2">
    <button
      type="button"
      class="tw-button inline-flex items-center justify-center gap-1.5 rounded-lg bg-[var(--theme-color)] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] active:scale-[0.98]"
      (click)="applyFilters()"
    >
      <lucide-icon name="Search" [size]="16" /> ค้นหา
    </button>
    <button
      type="button"
      class="tw-button inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50"
      (click)="resetFilters()"
    >
      <lucide-icon name="RotateCcw" [size]="15" /> ล้างค่า
    </button>
  </div>
  </div>

  <div class="flex flex-col gap-4 border-b border-slate-200 px-5 py-4 lg:flex-row lg:items-end lg:justify-between sm:px-6">
    <div>
      <h2 class="m-0 text-base font-bold text-slate-800">รายการเคลื่อนไหวทางการเงิน</h2>
      <p class="mt-1 mb-0 text-xs text-slate-500">
        รายรับเฉพาะยอดที่ตรวจสอบแล้ว และรายจ่ายเฉพาะยอดที่จ่ายแล้ว
      </p>
    </div>
    <div class="flex w-full flex-wrap items-center gap-2 lg:w-auto lg:justify-end">
      <span class="rounded-full bg-slate-100 px-2.5 py-1.5 text-[10px] font-semibold text-slate-600">
        {{ filteredItems().length }} รายการ
      </span>
      <span
        class="rounded-full bg-emerald-50 px-2.5 py-1.5 text-[10px] font-semibold text-emerald-700 tabular-nums"
        title="ยอดรวมรายรับ"
      >
        {{ incomeTotal() | number: '1.2-2' }}
      </span>
      <span
        class="rounded-full bg-rose-50 px-2.5 py-1.5 text-[10px] font-semibold text-rose-700 tabular-nums"
        title="ยอดรวมรายจ่าย"
      >
        {{ expenseTotal() | number: '1.2-2' }}
      </span>
      <label class="relative block w-full sm:w-80">
        <lucide-icon
          name="Search"
          [size]="16"
          class="pointer-events-none absolute top-1/2 left-3 z-10 -translate-y-1/2 text-slate-400"
        />
        <input
          pInputText
          type="search"
          class="h-10 w-full pr-3 text-sm placeholder:text-slate-400"
          style="padding-left: 2.75rem; border-radius: 0.5rem"
          placeholder="ค้นหาเลขที่รายการ, Booking, ชื่อลูกค้า หรือรายละเอียด"
          [ngModel]="searchTerm()"
          (ngModelChange)="searchTerm.set($event)"
        />
      </label>
    </div>
  </div>

  <p-table
    [value]="filteredItems()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    styleClass="cash-flow-table"
    [tableStyle]="{ 'min-width': '1120px' }"
  >
    <ng-template #header>
        <tr>
          <th class="w-14 px-5 py-3 text-center font-semibold">ลำดับ</th>
          <th pSortableColumn="transactionDate" class="min-w-44 px-5 py-3 font-semibold">
            วันที่และเลขที่รายการ <p-sortIcon field="transactionDate" />
          </th>
          <th pSortableColumn="bookingNo" class="min-w-52 px-5 py-3 font-semibold">
            Booking และลูกค้า <p-sortIcon field="bookingNo" />
          </th>
          <th pSortableColumn="category" class="min-w-44 px-5 py-3 font-semibold">
            ประเภทและช่องทาง <p-sortIcon field="category" />
          </th>
          <th class="min-w-56 px-5 py-3 font-semibold">รายละเอียด</th>
          <th pSortableColumn="amount" class="w-40 px-5 py-3 text-right font-semibold">
            รายรับ <p-sortIcon field="amount" />
          </th>
          <th pSortableColumn="amount" class="w-40 px-5 py-3 text-right font-semibold">
            รายจ่าย <p-sortIcon field="amount" />
          </th>
          <th class="w-24 px-5 py-3 text-center font-semibold">เอกสาร</th>
        </tr>
    </ng-template>

    <ng-template #body let-item let-rowIndex="rowIndex">
          <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/50">
            <td class="px-5 py-3.5 text-center text-[13px] text-slate-400 tabular-nums align-top">
              {{ rowIndex + 1 }}
            </td>
            <td class="px-5 py-3.5 align-top">
              <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800">
                {{ item.transactionDate | date: 'dd MMM yyyy' }}
              </p>
              <p class="mt-1 mb-0 text-xs font-medium whitespace-nowrap text-sky-700">
                {{ item.transactionNo }}
              </p>
            </td>
            <td class="px-5 py-3.5 align-top">
              <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">
                {{ item.bookingNo }}
              </p>
              <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.customerName }}</p>
            </td>
            <td class="px-5 py-3.5 align-top">
              <div class="flex items-center gap-2">
                <span
                  class="grid size-7 shrink-0 place-items-center rounded-lg"
                  [class.bg-emerald-50]="item.direction === 'INCOME'"
                  [class.text-emerald-600]="item.direction === 'INCOME'"
                  [class.bg-rose-50]="item.direction === 'EXPENSE'"
                  [class.text-rose-600]="item.direction === 'EXPENSE'"
                >
                  <lucide-icon
                    [name]="item.direction === 'INCOME' ? 'ArrowDownLeft' : 'ArrowUpRight'"
                    [size]="14"
                  />
                </span>
                <div>
                  <p class="m-0 text-sm font-medium text-slate-700">
                    {{ categoryLabel(item.category) }}
                  </p>
                  <p class="mt-1 mb-0 text-xs text-slate-500">
                    {{ paymentMethodLabel(item) }}
                  </p>
                </div>
              </div>
            </td>
            <td class="px-5 py-3.5 text-sm text-slate-600 align-top">
              {{ item.description }}
            </td>
            <td class="px-5 py-3.5 text-right text-sm font-semibold whitespace-nowrap tabular-nums align-top">
              @if (item.direction === 'INCOME') {
                <span class="text-emerald-700">{{ item.amount | number: '1.2-2' }}</span>
                @if (item.paymentMethod === 'CREDIT_CARD') {
                  <p class="mt-1 mb-0 text-[10px] font-normal whitespace-nowrap text-slate-500">
                    {{ creditCardFeeResponsibilityLabel(item.creditCardFeeResponsibility) }}
                    {{ item.creditCardFeeAmount | number: '1.2-2' }}
                  </p>
                }
              } @else {
                <span class="text-slate-300">—</span>
              }
            </td>
            <td class="px-5 py-3.5 text-right text-sm font-semibold whitespace-nowrap tabular-nums align-top">
              @if (item.direction === 'EXPENSE') {
                <span class="text-rose-700">{{ item.amount | number: '1.2-2' }}</span>
              } @else {
                <span class="text-slate-300">—</span>
              }
            </td>
            <td class="px-5 py-3.5 text-center align-top">
              @if (item.documentUrl) {
                <button
                  type="button"
                  class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
                  title="เปิดเอกสาร"
                  (click)="openDocument(item.documentUrl)"
                >
                  <lucide-icon name="ExternalLink" [size]="15" />
                </button>
              } @else {
                <span class="text-sm text-slate-400">—</span>
              }
            </td>
          </tr>
    </ng-template>

    <ng-template #emptymessage>
          <tr>
            <td colspan="8" class="px-5 py-12 text-center">
              <div class="mx-auto grid size-12 place-items-center rounded-full bg-slate-100 text-slate-400">
                <lucide-icon name="SearchX" [size]="21" />
              </div>
              <h3 class="mt-3 mb-0 text-sm font-semibold text-slate-700">ไม่พบรายการรับ–จ่าย</h3>
              <p class="mt-1 mb-0 text-xs text-slate-500">ลองเปลี่ยนคำค้นหา ช่วงวันที่ หรือตัวกรอง</p>
            </td>
          </tr>
    </ng-template>
  </p-table>
</section>
